import PortImg1 from "../assets/images/resources/portImg1-1.jpg";
import PortImg2 from "../assets/images/resources/portImg1-2.jpg";
import PortImg3 from "../assets/images/resources/portImg1-3.jpg";
import PortImg4 from "../assets/images/resources/portImg1-4.jpg";
import PortImg5 from "../assets/images/resources/portImg1-5.jpg";
import PortImg6 from "../assets/images/resources/portImg1-6.jpg";
import PortImg7 from "../assets/images/resources/portImg1-7.jpg";

export const portfolio = [
  {
    id: 1,
    portBox: "basis-full md:basis-[41.57%] px-[.9375rem]",
    portImg: PortImg1,
    portTitle: "Graphic Illustration",
    portSubTitle: "Flat Design stock illustration",
    portcate: "graphic",
  },
  {
    id: 2,
    portBox: "basis-full md:basis-[58.3%] px-[.9375rem]",
    portImg: PortImg2,
    portTitle: "Efficient Team Mobile",
    portSubTitle: "Flat Design stock illustration",
    portcate: "development",
  },
  {
    id: 3,
    portBox: "basis-full md:basis-2/6 px-[.9375rem]",
    portImg: PortImg3,
    portTitle: "UI/UX Creative Design",
    portSubTitle: "Flat Design stock illustration",
    portcate: "figma",
  },
  {
    id: 4,
    portBox: "basis-full md:basis-2/6 px-[.9375rem]",
    portImg: PortImg4,
    portTitle: "Mobile Illustration",
    portSubTitle: "Flat Design stock illustration",
    portcate: "illustration",
  },
  {
    id: 5,
    portBox: "basis-full md:basis-2/6 px-[.9375rem]",
    portImg: PortImg5,
    portTitle: "Anaylsis Application",
    portSubTitle: "Flat Design stock illustration",
    portcate: "development",
  },
  {
    id: 6,
    portBox: "basis-full md:basis-[58.3%] px-[.9375rem]",
    portImg: PortImg6,
    portTitle: "Business Growth",
    portSubTitle: "Flat Design stock illustration",
    portcate: "illustration",
  },
  {
    id: 7,
    portBox: "basis-full md:basis-[41.57%] px-[.9375rem]",
    portImg: PortImg7,
    portTitle: "Profitable Business",
    portSubTitle: "Flat Design stock illustration",
    portcate: "graphic",
  },
];
